import axios from 'axios'

import { API_URL } from '@/constants'
import store from "@/store";
import Cookies from "js-cookie";

const client = axios.create({
  baseURL: API_URL
})

client.interceptors.request.use(async (config) => {
  const token = await store.state.auth.auth.getTokenString();
  if (!token) {
    return Promise.reject();
  }
  Cookies.set('token', token);
  return config;
})


export default client